export enum IdentificationTypeEnum {
  Cedula = 1,
  Passport
}
